import jquery from 'jquery';
window.jQuery = jquery;
window.$ = jquery;


// WEBPACK FOOTER //
// ./scripts/components/jquery-global.js